// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"594":"about","722":"notFound"}[chunkId] + "." + {"594":"4afa845d","722":"d1138786"}[chunkId] + ".js";
};